import * as R from 'ramda';
import { ActionType } from '../../core/redux/actionType';
import { makeApiAction, makeRsaaTypes, ApiReducer, makeApiReducer } from '../../core/api/rsaa';
import { Endpoints } from '../../core/api/endpoints';
import { getLoading, addLoading, addError, noLoadingNoError } from '../../core/api/module';
import { EmailBody } from '../../project/survey/raters/models';


const KEY_ACTION = ActionType.RaterApprovalEmailPreviewRequest;
const ACTIONS    = [
  ActionType.RaterApprovalEmailPreviewRequest,
  ActionType.RaterApprovalEmailPreviewResponse,
  ActionType.RaterApprovalEmailPreviewError,
];


type Payload = EmailBody;


type Meta = {
  projectId: number;
  languageId: number;
};


/**
 * Dispatch this action to send invitation emails to all as-yet uninvited raters who have been added to the given
 * project for the listed participant
 */
export const raterApprovalEmailPreviewAction = (projectId: number, languageId: number) => makeApiAction<Payload, Meta>(
  {
    method:   'POST',
    endpoint: Endpoints.RaterApprovalEmailPreview,
    headers:  { 'content-type': 'application/json' },
    body:     JSON.stringify({
      projectId:  projectId,
      languageId: languageId,
    }),
    types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { projectId, languageId }),
    bailout:  state => !!getLoading(state, KEY_ACTION, `${projectId}-${languageId}`),
  },
);

const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  const projectId = action.meta.projectId;
  const languageId = action.meta.languageId;
  const metaTag = `${projectId}-${languageId}`;

  if (isLoading) {
    return addLoading(state, KEY_ACTION, metaTag);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg, metaTag);
  }

  const successState = noLoadingNoError(state, KEY_ACTION, metaTag);

  return R.assocPath(
    ['raterApprovalEmailTemplates', `${projectId}`, `${languageId}`],
    payload,
    successState,
  );
};

export const raterApprovalEmailPreviewReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
